import { render } from "./SecondaryCards.vue?vue&type=template&id=52edcc12"
import script from "./SecondaryCards.vue?vue&type=script&lang=js"
export * from "./SecondaryCards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__